import { Injectable } from "@angular/core";
import { ID, QueryEntity } from "@datorama/akita";
import { Observable } from "rxjs";
import { KeyvalueState, KeyvalueStore } from "./keyvalue.store";
import { IKeyvalue } from "@common/interfaces/keyvalue";
import { ProjectQuery } from "../project/project.query";
import { IGisfoKeyValue } from "@common/interfaces/gisfo";

@Injectable({
  providedIn: 'root'
})
export class KeyvalueQuery extends QueryEntity<KeyvalueState> {

  constructor(protected store: KeyvalueStore, private projectQuery: ProjectQuery) {
    super(store);
  }

  selectKeyvaluesByProjectIdAndCategory(projectId: ID, category: string): Observable<IKeyvalue[]> {
    return this.selectAll({
      filterBy: entity => entity.projectId === projectId && entity.category === category
    })
  }

  selectActivityTypesByProjectId(projectId: ID): Observable<IKeyvalue[]> {
    return this.selectAll({
      filterBy: entity => entity.projectId === projectId && entity.category === 'activity_type'
    })
  }

  getKeyvaluesByProjectIdAndCategory(projectId: ID, category: string): IKeyvalue[] {
    return this.getAll().filter(keyvalue => keyvalue.projectId === projectId && keyvalue.category === category);
  }

  getActivityTypesByActiveProject(): IKeyvalue[] {
    return this.getAll().filter(keyvalue => keyvalue.projectId === this.projectQuery.getActiveId() && keyvalue.category === 'activity_type');
  }

  getActivityTypesByProjectId(projectId: ID): IKeyvalue[] {
    return this.getAll().filter(keyvalue => keyvalue.projectId === projectId && keyvalue.category === 'activity_type');
  }

  getNetTestResultsByActiveProject(): IKeyvalue[] {
    return this.getAll().filter(keyvalue => keyvalue.projectId === this.projectQuery.getActiveId() && keyvalue.category === 'net_test_result');
  }

  getNetEvidenceTypesByActiveProject(): IKeyvalue[] {
    return this.getAll().filter(keyvalue => keyvalue.projectId === this.projectQuery.getActiveId() && keyvalue.category === 'net_test_type' && (keyvalue.metadata as IGisfoKeyValue).is_evidence);
  }

  getNetTestTypesByActiveProject(): IKeyvalue[] {
    return this.getAll().filter(keyvalue => keyvalue.projectId === this.projectQuery.getActiveId() && keyvalue.category === 'net_test_type' && !(keyvalue.metadata as IGisfoKeyValue).is_evidence);
  }

  getNetInterventionTypesByActiveProject(): IKeyvalue[] {
    return this.getAll().filter(keyvalue => keyvalue.projectId === this.projectQuery.getActiveId() && keyvalue.category === 'net_failure_fix_type');
  }

}
